<template>
  <div class="group group--sidebar">
    <h1 
      :style="{ 'color': org.custom_color1 == null ? '': org.custom_color1 }"
      class="h1 group__title mw600">How would you like to <br class="hide-below-medium"> talk to your counselor?</h1>

    <ul class="appointment-type-list appointment-type-list--max-width">
      <li
        v-for="(item, index) in typesToShow"
        :key="index"
        @click="item.action(item.type)"
        :class="[
          `appointment-type-list__item appointment-type-list__item--small appointment-type-list__item--hover`,
          selectedAppointmentType === item.type ? `appointment-type-list__item--active` : ``,
        ]"
      >
        <div class="appointment-type-list__content appointment-type-list__content--fixed">
          <span
            :class="[
              `appointment-type-list__icon`,
              `appointment-type-list__icon--${item.icon}`,
            ]"
          />
          <span class="appointment-type-list__description fw-medium">{{ item.description }}</span>
        </div>
      </li>
    </ul>

    <p class="p appointment__note">For video chat, you’ll need a computer, tablet, or mobile phone with a camera.<br class="hide-below-small"> To talk over the phone, we’ll give you a call.</p>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'view-appointment',


  // Data
  data() {
    return {
      listItems: {
        video: {
          icon: 'video',
          type: 'video',
          description: 'By video chat',
          action: this.select,
        },
        phone: {
          icon: 'phone',
          type: 'phone',
          description: 'Over the phone',
          action: this.select,
        },
      },
    };
  },


  // Computed
  computed: {
    ...mapGetters('provider', ['selectedSlot', 'selectedAppointmentType']),
    ...mapGetters('appointment', ['tempAppointmentData']),
    ...mapGetters('app', ['org']),

    
    typesToShow() {
      if ( this.selectedSlot ) {
        const obj = _.clone(this.selectedSlot); // eslint-disable-line no-undef
        const items = [];

        _.forEach(obj.availability_type, type => { // eslint-disable-line no-undef
          items.push({
            ...this.listItems[type],
            phys_availability_id: obj.phys_availability_id,
          });
        });

        return items;
      }
    },
  },


  // Methods
  methods: {
    ...mapActions('provider', ['selectAppointmentType']),

    select(type) {
      this.selectAppointmentType(type);

      if ( this.tempAppointmentData ) {
        this.$store.dispatch('app/setConfirmMessage', 'Would you like to submit your new selected time request for a telehealth appointment now?');
        this.$store.dispatch('app/setConfirmDescription', 'You appointment will automatically be scheduled and you\'ll receive a confirmation email.');
        this.$store.dispatch('app/setConfirmButton', {
          label: 'Schedule Appointment',
          action: 'appointment/requestScheduleAppointment',
        });
      }

      this.$router.push({
        name: this.tempAppointmentData ? 'confirm' : 'register',
      });
    },
  },


  // Lifecycles
  created() {
    if ( !this.selectedSlot ) {
      this.$router.push({
        name: 'results',
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// Appointment.vue?04be13fc